import * as React from 'react'
import type { SVGProps } from 'react'
const SvgCreditCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M28.5 10.125H7.5C7.01675 10.125 6.625 10.5168 6.625 11V25C6.625 25.4832 7.01675 25.875 7.5 25.875H28.5C28.9832 25.875 29.375 25.4832 29.375 25V11C29.375 10.5168 28.9832 10.125 28.5 10.125Z'
      stroke={props.stroke}
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M22.375 22.375H25.875'
      stroke={props.stroke}
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M17.125 22.375H18.875'
      stroke={props.stroke}
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M6.625 14.5H29.375'
      stroke={props.stroke}
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)
export default SvgCreditCard
